import { useState } from 'react'
import { LegacyAntdModal } from 'components/LegacyAntdModal/LegacyAntdModal'
import Styles from './WorkflowReassignmentsModal.module.scss'
import { WorkflowReassignmentsModalProps } from './Types'
import { Button } from 'components/Button'
import { State } from 'stores/Workflows/State'
import { observer } from 'mobx-react-lite'
import { Row } from './Row'

const WorkflowReassignmentsModal = observer(
  ({ statesToReassign, newStates, onConfirm, onCancel }: WorkflowReassignmentsModalProps) => {
    const [reassignments, setReassignments] = useState<Map<State, State>>(() => {
      const map = new Map()
      const defaultState = newStates.find((state) => state.isDefault)
      statesToReassign.forEach((state) => map.set(state, defaultState))
      return map
    })

    const handleSelectionChange = (fromState: State, toState: State) => {
      const newMap = new Map(reassignments.set(fromState, toState))
      setReassignments(newMap)
    }

    const handleConfirm = () => {
      onConfirm(reassignments)
    }

    return (
      <LegacyAntdModal
        visible
        onCancel={onCancel}
        wrapClassName={Styles.wrapper}
        footer={
          <div className={Styles.footer}>
            <div className={Styles.buttonsWrapper}>
              <Button variant="tertiary" size="lg" onPress={onCancel}>
                Cancel
              </Button>
              <Button size="lg" onPress={handleConfirm}>
                Confirm Changes
              </Button>
            </div>
          </div>
        }
        closable={false}
        width={650}
      >
        <div className={Styles.header}>
          <h2>Reassign files</h2>
        </div>
        <div className={Styles.body}>
          <p className={Styles.description}>
            The statuses below have been updated or deleted. For documents currently in the affected statuses, select an
            updated status below.
          </p>
          <div className={Styles.form}>
            <div className={Styles.columnHeader}>From</div>
            <div />
            <div className={Styles.columnHeader}>To</div>
            {Array.from(reassignments).map(([fromState, toState]) => (
              <Row
                key={fromState.key}
                fromState={fromState}
                toState={toState}
                newStates={newStates}
                onChange={handleSelectionChange}
              />
            ))}
          </div>
        </div>
      </LegacyAntdModal>
    )
  },
)

export { WorkflowReassignmentsModal }
